import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage/LandingPage";
import BasicInformation from "../../life-ui/src/components/BasicInformation/BasicInformation";
import Footer from "./components/Footer/Footer";
import ContainerLayout from "../../life-ui/src/components/Layout/ContainerLayout";
import AddBeneficiary from "./components/Beneficiary/Beneficiary";
import HealthQuestions from "./components/Questions/HealthQuestions/HealthQuestions";
import Summary from "./components/Summary/Summary";
import PersonalAccidentCover from "./components/PersonalAccidentCover/PersonalAccidentCover";
import PersonalInformation from "./components/PersonalInformation/PersonalInformation";
import PaymentDetails from "./components/PaymentDetails/PaymentDetails";
import PaymentSuccessful from "./components/PaymentSuccessful/PaymentSuccessful";
import PaymentUnsuccessful from "./components/PaymentUnSuccessful/PaymentUnSuccessful";
import TopNavBar from "./components/TopNavBar/TopNavBar";
import CustomDatePicker from "./components/DatePicker/DatePicker";
import SumAssuredPage from "./components/SumAssured/SumAssured";
import HealthQuestionsTerm from "./components/Questions/HealthQuestions/HealthQuestionsTerm";
import ScrollToTop from "./ScrollToTop";
import UploadDocument from "./components/UploadDocument/UploadDocument";
import ChoosePlan from "./components/ChoosePlan/ChoosePlan";

function RouteConfig() {
  return (
    <>
    <ScrollToTop /> 
      <Routes>
           {/* <Route path="/" element={<Navigate to="/life-insurance"/>} /> */}
        <Route path="/" element={<LandingPage />} />

        <Route
          path="/choose-your-product"
          backTo="/"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/">
              <ChoosePlan />
            </ContainerLayout>
          }
        />

        <Route
          path="/basic-information"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/" stepNo={1}
              totalSteps={4}>
              <BasicInformation />
            </ContainerLayout>
          }
        />

        {/* <Route
          path="/add-beneficiary"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <AddBeneficiary />
            </ContainerLayout>
          }
        /> */}
        <Route
          path="/add-beneficiary"
          element={<ContainerLayout bgImage="bg-image-life" backTo="/personal-accident-cover"><AddBeneficiary /></ContainerLayout>}
        />

        {/* <Route
          path="/question/health"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <HealthQuestions />
            </ContainerLayout>
          }
        /> */}
         <Route
          path="/question/life-Personal"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/personal-information" stepNo={3}
              totalSteps={4}>
              <HealthQuestions />
            </ContainerLayout>
          }
        />

        {/* <Route
          path="/summary"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <Summary />
            </ContainerLayout>
          }
        /> */}
         <Route
          path="/summary"
          element={
            <ContainerLayout  backTo="/question/health"  stepNo={4}
              totalSteps={4}>
              <Summary />
            </ContainerLayout>
          }
        />

        {/* <Route
          path="/personal-accident-cover"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <PersonalAccidentCover />
            </ContainerLayout>
          }
        /> */}
        <Route
          path="/personal-accident-cover"
          element={<ContainerLayout bgImage="bg-image-life" backTo="/basic-information"><PersonalAccidentCover /></ContainerLayout>}
        />

        {/* <Route
          path="/personal-information"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <PersonalInformation />
            </ContainerLayout>
          }
        /> */}
        <Route
          path="/personal-information"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/add-beneficiary"  stepNo={2}
              totalSteps={4}>
              <PersonalInformation />
            </ContainerLayout>
          }
        />
        <Route path="/date-picker" element={<CustomDatePicker />} />

        {/* <Route
          path="/payment-details"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <PaymentDetails />
            </ContainerLayout>
          }
        /> */}

         <Route
          path="/payment-details"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/summary" >
              <PaymentDetails />
            </ContainerLayout>
          }
        />

        {/* ✅ Success Route */}

        <Route
          path="/payment-result"
          element={<ContainerLayout showHeader={false}><PaymentSuccessful /></ContainerLayout> }
        />

        {/* 🚫 Unsuccessful Route */}
        <Route
          path="/payment-error"
          element={<ContainerLayout showHeader={false}><PaymentUnsuccessful /></ContainerLayout> }
        />
         {/* <Route
          path="/sum-assured"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <SumAssuredPage/>
            </ContainerLayout>
          }
        />  */}
         <Route
          path="/sum-assured"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/basic-information" >
              <SumAssuredPage/>
            </ContainerLayout>
          }
        />
        {/* <Route
          path="/question/life"
          element={
            <ContainerLayout bgImage="bg-image-life" >
              <HealthQuestionsTerm/>
            </ContainerLayout>
          }
        /> */}
         <Route
          path="/question/life-term"
          element={
            <ContainerLayout bgImage="bg-image-life" backTo="/personal-information"   stepNo={3}
              totalSteps={4}>
              <HealthQuestionsTerm/>
            </ContainerLayout>
          }
        />
      </Routes>
     {/* <Footer /> */}
    </>
  );
}

export default RouteConfig;
